import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42oWNSQqAMBDA5v8v9FCEorSK9KjdxonFB2ggt0CEb1TqVcj7Qk8J8x47ViwPSwTrKj0XaphoW8Scw8LwnN+Iu6n8LR4zsXzfkYSqOQAAAABJRU5ErkJggg=="};
